import ReportStat from './ReportStat'

export default ReportStat
